import {AppliedFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {useTranslation} from '@aboutyou/i18n';
import {FilterFlyoutAppliedFilters} from '@aboutyou/ui-components';
import React from 'react';
import {usePotentialFilters} from '../../../ProductStream/utils';
import {useNormalizedAppliedFilters} from '../../shared/useNormalizedAppliedFilters';

type Props = {
  data: AppliedFilterSection;
  enableFlyoutFilter: boolean;
};

const FilterSectionAppliedFilters: React.FC<Props> = ({
  data,
  enableFlyoutFilter,
}) => {
  const {t} = useTranslation();

  const appliedFilters = useNormalizedAppliedFilters(data.values);
  const {resetAllFilters, removeFilter} = usePotentialFilters();

  return (
    <FilterFlyoutAppliedFilters
      activeFilters={appliedFilters}
      label={t('Filtered with')}
      onButtonClick={({id, slug}) => {
        removeFilter(slug, id);
      }}
      resetAllFilters={resetAllFilters}
      enableFlyoutFilter={enableFlyoutFilter}
    />
  );
};

export {FilterSectionAppliedFilters};
